import { Component, Input, OnInit } from '@angular/core';
import { CardToken, CardTokenQuery } from '@fgb/core';
import { Observable, tap } from 'rxjs';

@Component({
  selector: 'fgb-ecash-button',
  templateUrl: './ecash-button.component.html',
  styleUrls: ['./ecash-button.component.scss'],
})
export class EcashButtonComponent implements OnInit {
  @Input() isMemberCard: boolean = false;
  @Input() showCardExpiry: boolean = false;
  cardToken$: Observable<CardToken | undefined>;
  isCardExpired: boolean = false;

  constructor(private cardTokenQuery: CardTokenQuery) {}

  ngOnInit(): void {
    this.cardToken$ = this.cardTokenQuery.selectDefaultCard().pipe(
      tap((cardToken) => {
        if (cardToken && new Date(cardToken.ExpiryDate as Date) < new Date()) {
          this.isCardExpired = true;
        } else {
          this.isCardExpired = false;
        }
      })
    );
  }
}
